import { render, staticRenderFns } from "./comp_FlipBook.vue?vue&type=template&id=4c59a592&scoped=true&"
import script from "./comp_FlipBook.vue?vue&type=script&lang=js&"
export * from "./comp_FlipBook.vue?vue&type=script&lang=js&"
import style0 from "./comp_FlipBook.vue?vue&type=style&index=0&id=4c59a592&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c59a592",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VIcon})
